// removed by extract-text-webpack-plugin
module.exports = {"logo":"logo_3rkOq","payoff":"payoff_LyLuj"};


//////////////////
// WEBPACK FOOTER
// ./app/components/logo/styles.scss
// module id = 445
// module chunks = 1